import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

/** Formats accepted when typing into the range fields. */
const TYPED_DATE_FORMATS = [
  "YYYY-MM-DD",
  "M/D/YYYY",
  "MM/DD/YYYY",
  "M/D/YY",
  "MM/DD/YY",
  "MMM D, YYYY",
  "MMM DD, YYYY",
  "MMMM D, YYYY",
  "MMMM DD, YYYY",
  "D MMM YYYY",
  "DD MMM YYYY",
  "D MMMM YYYY",
  "DD MMMM YYYY",
] as const;

export const toDay = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

/**
 * Parse a typed date string.
 * - empty / whitespace → null (cleared bound)
 * - unparseable or incomplete → "invalid"
 * - otherwise a local calendar day
 */
export const parseTypedDate = (text: string): Date | null | "invalid" => {
  const trimmed = text.trim();
  if (!trimmed) {
    return null;
  }

  for (const format of TYPED_DATE_FORMATS) {
    const parsed = dayjs(trimmed, format, true);
    if (parsed.isValid()) {
      return toDay(parsed.toDate());
    }
  }

  return "invalid";
};

export const isRangeReversed = (
  start: Date | null,
  end: Date | null,
): boolean => {
  if (!start || !end) {
    return false;
  }
  return toDay(start).getTime() > toDay(end).getTime();
};
